/**
 * Created by ianva on 16/4/13.
 * update babuwang 16/6/3
 * 同步后端状态
 */


var orderError = {
        code: -1,
        text: '状态失败'
    }
var noOrder ={
        code: 0,
        text: '无订单'
    }
var waitingForPay = {
        code: 1,
        text: '等待付款'
    }
var partPayed  = {
        code: 2,
        text: '付定金'
    }
var fullPayed = {
        code: 3,
        text: '付全款'
    }
var tradeClose = {
        code: 4,
        text: '交易关闭'
    }


module.exports  = {
    orderError,
    noOrder,
    waitingForPay,
    partPayed,
    fullPayed,
    tradeClose,
    list: [orderError, noOrder, waitingForPay, partPayed, fullPayed, tradeClose]
}


/** WEBPACK FOOTER **
 ** ./script/conf/order-status.js
 **/